module.exports = __webpack_public_path__ + "img/ic_shopping_cart.8911251b.svg";